module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"manuallyDeactivated":"Manually deactivated"},"de":{"manuallyDeactivated":"Manuell deaktiviert"},"fr":{"manuallyDeactivated":"Désactivé manuellement"},"it":{"manuallyDeactivated":"Disattivato manualmente"}}')
  delete Component.options._Ctor
}
